import { type JanusCtx, type Row, ecId, ecLean, record, upper } from './context.js';
import { phpJsonTruthy } from '../compile/php-json-values.js';

const FRIEND = '7DBEB6D4-D147-703A-022E-05B290BB95C3';
const ENEMY = '9399856B-2132-7574-1684-91139A2831DD';

/** Shared encounter/layer team reader, including compiled item-shaped team ids. */
function creatureTeam(ctx: JanusCtx, row: Row): string {
  const raw = ecLean(row, 'team') ?? ctx.read.value(row, 'team');
  return upper(record(raw)?.items ? record(record(raw)?.items)?.item_id : raw);
}

/** includes/functions/janus/core/check_opposing_team.php:check_opposing_team */
export function checkOpposingTeam(ctx: JanusCtx, caster: Row, target: Row): boolean {
  const casterTeam = creatureTeam(ctx, caster);
  const targetTeam = creatureTeam(ctx, target);
  return (casterTeam === FRIEND || casterTeam === ENEMY)
    && (targetTeam === FRIEND || targetTeam === ENEMY)
    && casterTeam !== targetTeam;
}

/** Retired contest_skip_helpers.php:16–34: self or an exact cooperative team, never neutral/unknown equality. */
export function contestSkippedForWillingTarget(ctx: JanusCtx, ability: Row, caster: Row, target: Row): boolean {
  const rider = record(ability.attack_ability_arr);
  if (![ability, rider].some(row => row && phpJsonTruthy(ctx.read.value(row, 'contesting_roll_skipped_for_same_team_type')))
      || !ecId(target)) return false;
  if (ecId(caster) === ecId(target)) return true;
  const team = creatureTeam(ctx, caster);
  return (team === FRIEND || team === ENEMY) && team === creatureTeam(ctx, target);
}
